var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarttick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0965 14.7621C26.0965 13.0373 25.1164 11.5318 23.6856 10.7716C24.0764 9.28277 23.6957 7.62728 22.5336 6.46571C21.6661 5.59764 20.5229 5.16598 19.3785 5.16598C18.9913 5.16598 18.6041 5.2152 18.2276 5.31422C17.4681 3.88345 15.9626 2.90332 14.2377 2.90332C12.5129 2.90332 11.0074 3.88345 10.2472 5.31422C9.87012 5.2152 9.48353 5.16598 9.09634 5.16598C7.95196 5.16598 6.80936 5.59824 5.9413 6.46571C4.77973 7.62728 4.39846 9.28218 4.78921 10.7716C3.35904 11.5318 2.37891 13.0373 2.37891 14.7621C2.37891 16.487 3.35904 17.9925 4.7898 18.7526C4.39906 20.2415 4.77972 21.897 5.94189 23.0586C6.80936 23.926 7.95255 24.3583 9.09693 24.3583C9.48412 24.3583 9.87131 24.3091 10.2478 24.2101C11.0074 25.6408 12.5129 26.621 14.2377 26.621C15.9626 26.621 17.4681 25.6408 18.2282 24.2101C18.6053 24.3091 18.9919 24.3583 19.3791 24.3583C20.5235 24.3583 21.6661 23.926 22.5342 23.0586C23.6957 21.897 24.077 20.2421 23.6862 18.7526C25.1164 17.9925 26.0965 16.487 26.0965 14.7621Z",
    fill: "#1593BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0513 19.9962L8.65527 15.5996L10.3321 13.9227L13.0513 16.6413L18.7353 10.958L20.4121 12.6348L13.0513 19.9962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarttick);
export default __webpack_public_path__ + "static/media/carttick.5ac72a5a24f07de1bd995e6d8348a384.svg";
export { ForwardRef as ReactComponent };